export default {"src":"/_next/static/image/public/images/ic_checkbox_checked_green.8da4373c62cbec471f7fc5be3e62271a.svg","height":20,"width":20};